import type { DatasetGpsEditorWrapperProps } from "./dataset-gps-editor.type";

import DatasetGpsEditor from "./dataset-gps-editor.component";

const DatasetGpsEditorWrapper = ({
  template,
  ...props
}: DatasetGpsEditorWrapperProps) => {
  if (!template) return null;

  return <DatasetGpsEditor {...props} template={template} />;
};

export default DatasetGpsEditorWrapper;
